import { Injectable } from '@angular/core';
import gql from 'graphql-tag';
import { GraphQLClient } from '../shared/services/graph-qlclient.service';

@Injectable({
  providedIn: 'root'
})
export class VendedorRubroClienteService {

  constructor(private gqlclient: GraphQLClient) {
  }

  GetByCliente(inputData, callback: Function) {
    const inputParams = this.createInputParamsGetByCliente(inputData)
    this.executeQueryObtenerSegunFiltroRubroeIPT(inputParams, callback)
  }

  GetAllVendedores(inputData, callback: Function) {
    const inputParams = this.createInputParamsGetVendedores(inputData)
    this.executeQueryObtenerSegunFiltro(inputParams, callback)
  }

  // FV: Lo hago a modo de limpiar la data de parámetros innecesarios y para direccionar la query en pro del contexto
  private createInputParamsGetByCliente({ rutEmpresa, sucursalCodigo, rutCliente, direccionCodigo }) {
    return {
      rutEmpresa,
      sucursalCodigo,
      rutCliente,
      direccionCodigo,
    }
  }

  private createInputParamsGetVendedores({ rutEmpresa, sucursalCodigo}) {
    return {
      rutEmpresa,
      sucursalCodigo
    }
  }

  private executeQueryObtenerSegunFiltroRubroeIPT(inputParams: any, callback: Function) {
    this.gqlclient.query(
      {
        query: gql`
        query(
          $rutEmpresa: Decimal
          $sucursalCodigo: Decimal
          $rutCliente: Decimal
          $direccionCodigo: Decimal
        ) {
          vendedor_rubro_cliente {
            obtenerSegunFiltroRubroeIPT(
              filtro: {
                exacto: {
                  rut_empresa: $rutEmpresa
                  sucursal_codigo: $sucursalCodigo
                  cliente_proveedor_rut: $rutCliente
                  direccion_codigo: $direccionCodigo
                  vendedor_codigo: -1
                  rubro_codigo: -1
                }
              }
            ) {
              respuesta {
                registros {
                  cliente_proveedor_rut
                  direccion_codigo
                  lunes
                  martes
                  miercoles
                  jueves
                  viernes
                  sabado
                  domingo
                  es_cobrador
                  nombreRubro
                  nombreVendedor
                  realiza_cobro_maquina
                  rubro_codigo
                  vendedor_codigo
                  listaUnidadNegocio
                }
              }
            }
          }
        }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { respuesta } = response.data.vendedor_rubro_cliente.obtenerSegunFiltroRubroeIPT
        if (!respuesta) {
          callback(null)
          return
        }

        const { registros } = respuesta
        callback({ registros })
      }
    );
  }


  private executeQueryObtenerSegunFiltro(inputParams: any, callback: Function) {
    this.gqlclient.query(
      {
        query: gql`
        query ($rutEmpresa: Decimal, $sucursalCodigo: Decimal) {
          vendedor {
            obtenerSegunFiltro(filtro: {exacto: {rut_empresa: $rutEmpresa, sucursal_codigo: $sucursalCodigo, tipobusqueda: 1}}) {
              mensajes {
                codigo
                contexto
                texto
              }
              respuesta {
                registros {
                  codigo
                  rut_empresa
                  sucursal_codigo
                  nombre
                  rut
                }
              }
            }
          }
        }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { respuesta } = response.data.vendedor.obtenerSegunFiltro
        if (!respuesta) {
          callback(null)
          return
        }

        const { registros } = respuesta
        callback({ registros })
      }
    );
  }

}
